exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/components/servicio-especial-list/servicio-especial-list.component.css
// module id = ../../../../../src/app/components/servicio-especial-list/servicio-especial-list.component.css
// module chunks = main